import React, { ComponentType } from 'react';
import { Typo3Context } from '.';
import { Translate } from './types';

export interface WithTypo3TranslationProps {
  typo3Translate: Translate;
}

export function withTypo3Translation<Props = {}>(
  WrappedComponent: ComponentType<Props & WithTypo3TranslationProps>
) {
  const WrapperComponent: ComponentType<Props> = props => (
    <Typo3Context.Consumer>
      {({ translateTypo3 }) => (
        <WrappedComponent {...props} typo3Translate={translateTypo3} />
      )}
    </Typo3Context.Consumer>
  );
  WrapperComponent.displayName = `withTypo3Translation(${WrappedComponent.displayName ||
    WrappedComponent.name ||
    'Component'})`;
  return WrapperComponent;
}
